module.exports = __webpack_public_path__ + "img/products8.b22c15b9.jpg";